import { Typography, Box, TextField, Grid, MenuItem } from '@mui/material';
import { doctorOptions, diagnosisTests, diagnoses, conditionOptions, observerGroups } from '../constants/options';

const ConsentAcknowledgementSection = ({ formData, handleNameChange, handleChange }) => {
  return (
    <Box sx={{ mt: 4, p: 3, border: '1px solid #c5ececff', borderRadius: 2,  }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 3, fontWeight: 'bold' }}>
        Step 3: Patient Certification & Acknowledgement
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* Point 4 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }}>
          4. I have been informed about the nature of my disease, the procedure(s) and its prognosis, the alternative to this operative treatment and risk of not having the procedure(s) and cost of the treatment have been explained. I have also been advised about the anticipated and unanticipated complications. After considering all these I have arrived at this decision to undergo the operation.
        </Typography>

        {/* Point 5 */}
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
            5. I authorize Dr.
          </Typography>
          <TextField
              select
              size="small"
              name="authorize_dr"
              value={formData.authorize_dr || ''}
              onChange={handleChange}
              sx={{ minWidth: 250, mb: 1 }}
            >
              <MenuItem value="">Select Doctor</MenuItem>
              {doctorOptions.map(doc => <MenuItem key={doc} value={doc}>{doc}</MenuItem>)}
            </TextField>
          <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }}>
            and such assistants and associates as may be selected by her/his to perform any part of the above procedure upon myself. I have been advised and I agree that any member of this team may perform any part of my procedure(s) according to his/her stage of training and ability if in the option of above named surgeon, the experience and he capability of the assistant surgeon justifies such a decision.
          </Typography>
        </Box>

        {/* Point 6 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }}>
          6. As with any procedure am aware that risk such as blood loss infection, heart failure, change in blood pressure, anesthetic / allergic reactions, blood clot in let etc. may arise necessitating attention, Therefore, in addition to consenting to the performance of the particular procedure(s), also consent and authorize the rendering of such other care and treatment as the surgeon or his designee reasonably believes necessary, Should on or more these and or other unforeseeable events occur.
        </Typography>

        {/* Point 7 */}
        <Box>
          <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }}>
            7. I consent to the photography or televising of the procedure to be performed for the purpose of advancing medical education; or its publication in scientific journals provided my identity is not revealed by the picture descriptions in the accompanying texts. I also consent to and authorize the presence of and observation of this procedure by qualified observers, as may be authorized by 
            <TextField
              select
              size="small"
              name="authorize_by"
              value={formData.authorize_by || ''}
              onChange={handleChange}
              sx={{ minWidth: 150, mx: 1, verticalAlign: 'middle' }}
            >
              <MenuItem value="">Select Group</MenuItem>
              {observerGroups.map(g => <MenuItem key={g} value={g}>{g}</MenuItem>)}
            </TextField>
            and its regulatory laws and agencies.
          </Typography>
        </Box>

        {/* Point 8 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }}>
          8. I give consent to the administration of blood product transfusion this procedure or immediate post operative period. I have been informed that despite careful screening in accordance with national and international regulation, there are rare instance of the life threatening infection such as AIDS, hepatitis and other viruses or diseases as yet unknown for which screening test do not exist. I also understand that unpredictable reactions may occur which include but are not breath. Shock and in rare occasions death.
        </Typography>

        {/* Point 9 */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="body2">9. The patient and/or family members are informed about the results of the diagnostic tests like</Typography>
          <TextField
              select
              size="small"
              name="diagnosis_like"
              value={formData.diagnosis_like || ''}
              onChange={handleChange}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Select</MenuItem>
              {diagnosisTests.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
            </TextField>
          <Typography variant="body2">and the diagnosis</Typography>
          <TextField
              select
              size="small"
              name="diagnosis"
              value={formData.diagnosis || ''}
              onChange={handleChange}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Select</MenuItem>
              {diagnoses.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
            </TextField>
          <Typography variant="body2">in the language they understand by Dr.</Typography>
          <TextField
              select
              size="small"
              name="diagnosis_dr"
              value={formData.diagnosis_dr || ''}
              onChange={handleChange}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Select Doctor</MenuItem>
              {doctorOptions.map(doc => <MenuItem key={doc} value={doc}>{doc}</MenuItem>)}
            </TextField>
        </Box>

        {/* Point 10 */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="body2">10. The patient and/or family members were explained about any change in the patient's condition like</Typography>
          <TextField
              select
              size="small"
              name="condition_like"
              value={formData.condition_like || ''}
              onChange={handleChange}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Select</MenuItem>
              {conditionOptions.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
            </TextField>
          <Typography variant="body2">in a periodic manner in the language they understand by Dr.</Typography>
          <TextField
              select
              size="small"
              name="understand_by_dr"
              value={formData.understand_by_dr || ''}
              onChange={handleChange}
              sx={{ minWidth: 150 }}
            >
              <MenuItem value="">Select Doctor</MenuItem>
              {doctorOptions.map(doc => <MenuItem key={doc} value={doc}>{doc}</MenuItem>)}
            </TextField>
        </Box>

        {/* Point 11 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
          11. I have been explained that for good long term results. I have to be on regular medical follow up and I undertake to abide by the advice given by the doctors.
        </Typography>

        {/* Point 12 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
          12. I know I must tell the doctor if I have had any other health problems, or any allergies to foods, or medicine, Also I must tell the doctor or nurse if I have had anything to eat, taken any drugs, medicine or alcohol since midnight.
        </Typography>

        {/* Point 13 */}
        <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
          13. I know specimens and tissues may be taken from my body during the procedure. I understand that it may be used for scientific reasons or in any way the doctor thinks best.
        </Typography>

        {/* Point 14 */}
        <Box>
          <Typography variant="body2" sx={{ mb: 1 }}>
            14. All the above details have been explained to me and doubts clarified in the language I understand by Dr.
          </Typography>
          <TextField
              select
              size="small"
              name="i_understood_by_dr"
              value={formData.i_understood_by_dr || ''}
              onChange={handleChange}
              sx={{ minWidth: 250, mb: 1 }}
            >
              <MenuItem value="">Select Doctor</MenuItem>
              {doctorOptions.map(doc => <MenuItem key={doc} value={doc}>{doc}</MenuItem>)}
            </TextField>
        </Box>

        <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 2 }}>
          After fully satisfying myself I hereby give my consent for the operation.
        </Typography>
      </Box>
    </Box>
  );
};

export default ConsentAcknowledgementSection;
